module.exports = __webpack_public_path__ + "static/DUC_8491-02-fa86a957045429c229cd50b171752faf.jpeg";